<template>
  <div class="floor-process">
    <div class="container">
      <div class="grids clearfix">
        <div class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/5_12.png'">
          <p class="grid-text">1、往返包邮，合作顺丰</p>
          <ProcessDots class="process-dots" :length="6"></ProcessDots>
        </div>
        <div class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/5_15.png'">
          <p class="grid-text">2、当日验机，行业前列</p>
          <ProcessDots class="process-dots" :length="6"></ProcessDots>
        </div>
        <div class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/5_18.png'">
          <p class="grid-text">3、极速收款，即刻回血</p>
          <ProcessDots class="process-dots" :length="6"></ProcessDots>
        </div>
        <div class="grid">
          <img class="grid-icon" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/5_21.png'">
          <p class="grid-text">4、数据清除，隐私安全</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProcessDots from '../../components/process-dots';
export default {
  components: {
    ProcessDots
  }
};
</script>

<style lang="postcss" scoped>
.floor-process {
  background-color: #fff;
}

.grid {
  position: relative;
  float: left;
  width: 25%;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  &-icon {
    width: 68px;
    height: 68px;
    margin-top: 30px;
  }
  &-text {
    margin-bottom: 30px;
  }
}

.process-dots {
  position: absolute;
  top: 62px;
  left: 253px;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-process.vue